import { useIntl } from 'react-intl';

import EmptyIcon from '@/assets/icons/empty-campaigns.svg';
import { EmptyState } from '@/components/ui/empty-state';

interface NoCampaignsProps {
  /** Search, filters, or date range are narrowing the list to zero rows. */
  isFiltered?: boolean;
}

export function NoCampaigns({ isFiltered }: NoCampaignsProps) {
  const intl = useIntl();

  if (isFiltered) {
    return (
      <EmptyState
        icon={EmptyIcon}
        header={intl.formatMessage({
          defaultMessage: 'No campaigns found',
          description:
            'Campaigns list returned zero rows for the current search or filters',
        })}
        description={intl.formatMessage({
          defaultMessage: 'Try adjusting your filters or search.',
          description:
            'Hint to change search or filters when the campaigns list is empty',
        })}
      />
    );
  }

  return (
    <EmptyState
      icon={EmptyIcon}
      header={intl.formatMessage({
        defaultMessage: 'No campaigns yet',
        description: 'Campaigns list is empty for the whole org',
      })}
      description={intl.formatMessage({
        defaultMessage:
          'Campaigns appear here once you post a job to a sourcing channel.',
        description: 'Explains why the campaigns list has no rows',
      })}
    />
  );
}
